import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Column, List, Row } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { isValidArray } from '../../utilities/validations';

const ArticleCard = ({ data, showCta = true, className }) => {
	const images = data?.modular_blocks?.find((item) => item.all_images != null)?.all_images?.imageConnection?.edges || data.modular_blocks.find((item) => item.all_images != null)?.all_images?.image;
	const cardDescription = data.top_content?.subheading || data.seo?.description;

	return (
		<div
			className={`articleCard relative flex h-full flex-col border border-black bg-white p-4 xl:p-6 ${className || ''}`}
			data-testid='article-card'
		>
			<CTA
				data={{ link: { href: data.url } }}
				renderAs='link'
				className='articleCard-link absolute left-0 top-0 z-1 h-full w-full -indent-full decoration-transparent'
			/>

			{isValidArray(images) && (
				<Row
					className={`articleCard-images aspect-[1.8] overflow-hidden ${images.length > 1 ? 'gap-x-4' : ''} mb-4 xl:mb-5`}
					noGutters
				>
					{images.map((img, index) => (
						<Column key={index}>
							<div className='relative h-full'>
								{images.length > 1 && (
									<Badge
										color='black'
										className='articleCard-badge absolute left-2 top-2 z-2 xl:left-2.5 xl:top-2.5'
									>
										{index === 0 ? 'Before' : 'After'}
									</Badge>
								)}

								{isValidArray(img?.node?.imageConnection?.edges) && (
									<Image
										data={{ image: img.node.imageConnection.edges[0].node }}
										className='h-full w-full object-cover'
									/>
								)}

								{img?.image?.url && (
									<Image
										data={img}
										className='h-full w-full object-cover'
									/>
								)}
							</div>
						</Column>
					))}
				</Row>
			)}

			{data.top_content?.heading && <p className='articleCard-heading text-subtitle font-bold'>{data.top_content.heading}</p>}

			{cardDescription && (
				<div
					className='articleCard-description text-body-2 mt-1'
					dangerouslySetInnerHTML={{ __html: cardDescription }}
				/>
			)}

			{showCta && (
				<List
					bullets='none'
					className='articleCard-links relative z-2 mt-auto flex flex-wrap items-center pt-4'
				>
					<li className='flex-12/12 md:flex-none'>
						<CTA
							data={{ link: { href: data.url, title: 'See Project Details' }, button_style: 'primary-alt', gtm_link_type: 'button' }}
							size='sm'
							className='articleCard-detailsCta'
						/>
					</li>
					{isValidArray(data.category_cta) && (
						<li className='mt-3 flex-12/12 md:ml-2.5 md:mt-0 md:flex-none'>
							<CTA
								data={data.category_cta[0]}
								size='sm'
								className='articleCard-categoryCta'
							/>
						</li>
					)}
				</List>
			)}
		</div>
	);
};

ArticleCard.propTypes = {
	data: PropTypes.object.isRequired,
	showCta: PropTypes.bool,
	className: PropTypes.string,
};

export default ArticleCard;
